import React, { FunctionComponent } from 'react'
import { Card, Col, Row, Typography } from 'antd'

import { CallData } from '../../../context/types'
import { formatTime } from '../../../utils/format'
import ProfileAvatar from '../ProfileAvatar/ProfileAvatar'

const { Paragraph, Title } = Typography

interface StepProps {
	call: CallData
	timezone: string
}

const ExpertCard: FunctionComponent<StepProps> = ({ call, timezone }) => {
	const expert = call.expert
	const date = new Date(Date.parse(call.start_time)).toLocaleDateString()

	if (!expert) return <></>

	return (
		<>
			<Card className="ExpertCard">
				<Row>
					<Col span={10}>
						<ProfileAvatar src={expert.profile.user.profile_pic_url} size={77} />
					</Col>
					<Col span={14}>
						<p className="ExpertCardInfo">
							Expert: {expert.profile.user.first_name} {expert.profile.user.last_name}
							<br />
							Date: {date}
							<br />
							Time: {formatTime(call.start_time, timezone)}
						</p>
					</Col>
				</Row>
			</Card>

			<Card style={{ marginTop: 20 }}>
				<Title level={5}>Call reason:</Title>
				<Paragraph>{call.reason}</Paragraph>
			</Card>
		</>
	)
}

export default ExpertCard
